import { Component, computed, input, output } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';

import { QuestionOption } from '@empathy/survey/base';
import { Question } from '@empathy/survey/base';

@Component({
  selector: 'empathy-single-choice-question-view',
  templateUrl: 'single-choice-question-view.component.html',
  styleUrls: ['./single-choice-question-view.component.scss', './_single-choice-question-view-theme.component.scss']
})
export class SingleChoiceQuestionViewComponent {
  question = input<Question>();
  questionGrp = input<FormGroup>();

  forceStop = output<boolean>();

  visibleOptions$ = computed(() => this.question().visibleOptions);
  useMedia$ = computed(() => this.question().visibleOptions.some((option) => !!option.stimulus?.mediaId));

  onCheck(option: Partial<QuestionOption>): void {
    this.questionGrp().get('value').setValue(option.value);

    this.questionGrp()
      .get('otherText')
      .setValidators(option.value === 'OTHER' ? [Validators.required] : []);
    this.questionGrp().get('otherText').updateValueAndValidity();
  }
}
